module.exports = __webpack_public_path__ + "static/Stephan-grobler-f8f80ea113f04335c33e8aef0b807b91.jpg";